import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=a8fcbc28"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fcbc28')) {
      api.createRecord('a8fcbc28', component.options)
    } else {
      api.reload('a8fcbc28', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=a8fcbc28", function () {
      api.rerender('a8fcbc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/Wrapper.vue"
export default component.exports